export const SITE = {
  name: "Ishan Jaiswal",
  title: "Ishan Jaiswal — Portfolio",
  description:
    "Modern, playful, and professional portfolio showcasing projects, skills, and creativity.",
  url: "https://ishan.vip",
  ogImage: "/site-preview.png",
  themeColorLight: "#F9FAFB",
  themeColorDark: "#0E0E0E",
  accent: {
    mint: "#00F5A0",
    pink: "#FF007F",
    violet: "#8C30FF",
  },
  keywords: [
    "Ishan Jaiswal",
    "Frontend Developer",
    "React",
    "TailwindCSS",
    "Vite",
    "Framer Motion",
    "Portfolio",
  ],
};

export const SOCIAL = {
  email: "me@ishan.vip",
  github: "https://github.com/NavIshanOp",
  linkedin: "https://www.linkedin.com/in/ishan-jaiswal-2a799a30a",
  instagram: "https://www.instagram.com/ishan_jaiswal10",
};

export const NAV_LINKS = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Projects", href: "#projects" },
//  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export const CONTACT = {
  formEndpoint: "https://formspree.io/f/manelqll",
  successMessage: "Thanks! Your message is on its way.",
  errorMessage: "Oops! Something went wrong. Please try again.",
};

export const META = {
  ogType: "website",
  twitterCard: "summary_large_image",
  robots: "index, follow",
  favicon: "/favicon.ico",
  logo: "/logo.png",
};
